// /Users/shawn/💼_WORKSPACE/Projects/FixPriceAI-Desktop/src/config/apiKeys.js
// Purpose: AI API configuration for FixPriceAI Desktop
// NOT for: Storing keys in production - use environment variables

export const API_KEYS = {
  // Google Gemini - Primary AI for image analysis and construction cost estimation
  GOOGLE_GEMINI: "AIzaSyD6PeLmdbYMnHa4UeZmioz5tW-Ix_-5bmc",

  // Groq - FREE unlimited backup AI (Llama 3.1 70B)
  GROQ: "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",

  // Ideogram - Image generation with text (95% accuracy)
  IDEOGRAM: "ajy26Y2OwMLhXnz_FF_-iyRRvPOLJPnpt6s4zs0gx3Gg3GdE6KLdTGUKcKOasp-fvHE1vkxeCMaL1YcUblmJhA",

  // ElevenLabs - Voice synthesis (Shawn's cloned voice)
  ELEVENLABS: "sk_0e3e215be936212521839a81df9a187c945cc5c175a996cf",
  ELEVENLABS_VOICE_ID: "yDVhT5liTKBkvScdl4hM",

  // Fal.ai - Video generation
  FAL_AI: "f04374e5-9a89-46d0-9799-b33b6e7053cc:d84e9e2c11c250f300f6f0eec9f27296"
};

export const AI_MODELS = {
  GEMINI: {
    text: "gemini-2.0-flash-exp",
    vision: "gemini-pro-vision",
    image: "imagen-3.0-generate-002"
  },
  GROQ: {
    text: "llama-3.3-70b-versatile",
    fast: "llama-3.1-8b-instant"
  }
};

export const AI_ENDPOINTS = {
  GEMINI: "https://generativelanguage.googleapis.com/v1beta/models",
  GROQ: "https://api.groq.com/openai/v1/chat/completions",
  IDEOGRAM: "https://api.ideogram.ai/generate",
  ELEVENLABS: "https://api.elevenlabs.io/v1/text-to-speech",
  FAL_AI: "https://fal.run/fal-ai/hunyuan-video"
};

// Polish construction cost database for demo
export const POLISH_CONSTRUCTION_COSTS = {
  "malowanie": { min: 15, max: 35, unit: "m²" },
  "gładź": { min: 25, max: 45, unit: "m²" },
  "kafelki": { min: 80, max: 150, unit: "m²" },
  "panele podłogowe": { min: 60, max: 120, unit: "m²" },
  "tynk": { min: 30, max: 60, unit: "m²" },
  "izolacja": { min: 40, max: 80, unit: "m²" },
  "okna": { min: 800, max: 2000, unit: "szt" },
  "drzwi": { min: 600, max: 1500, unit: "szt" },
  "instalacja elektryczna": { min: 100, max: 200, unit: "m" },
  "instalacja hydrauliczna": { min: 120, max: 250, unit: "m" }
};